import { toEmpfaengerListe } from './empfaenger';
import { htmlZuText } from '../aktionen/platzhalter';

// Baut aus einer emails-Zeile den Kontext für das Verfassen-Modal (EmailVerfassen-Props
// replyTo/forward) — einzige Stelle, die die Zeilen-Form in die Modal-Form übersetzt.
// text_inhalt fällt bei HTML-Mails ohne Text-Variante (z.B. graph-mail-sync) auf
// htmlZuText(html_inhalt) zurück, damit beim Zitieren kein roher HTML-Quelltext erscheint.

export interface ReplyKontext {
  id: string;
  von: string;
  betreff: string;
  html_inhalt?: string;
  text_inhalt?: string;
  message_id?: string;
  an: string[];
  cc: string[];
  /** „Allen antworten": die übrigen Empfänger der Ursprungsmail wandern ins Cc. */
  allen?: boolean;
  datum?: string;
}

export interface ForwardKontext {
  /** Ursprungsmail — das Formular holt darüber deren Anhänge und hängt sie erneut an. */
  id: string;
  betreff: string;
  html_inhalt?: string;
  text_inhalt?: string;
  datum?: string;
}

interface EmailZeile {
  id: string;
  von: string;
  betreff?: string | null;
  html_inhalt?: string | null;
  text_inhalt?: string | null;
  message_id?: string | null;
  an?: unknown;
  cc?: unknown;
  datum?: string | null;
}

export const replyKontextAusEmail = (email: EmailZeile, allen = false): ReplyKontext => ({
  id: email.id,
  von: email.von,
  betreff: email.betreff || '',
  html_inhalt: email.html_inhalt || undefined,
  text_inhalt: email.text_inhalt || (email.html_inhalt ? htmlZuText(email.html_inhalt) : undefined),
  message_id: email.message_id || undefined,
  an: toEmpfaengerListe(email.an),
  cc: toEmpfaengerListe(email.cc),
  allen,
  datum: email.datum || undefined,
});

export const forwardKontextAusEmail = (email: Pick<EmailZeile, 'id' | 'betreff' | 'html_inhalt' | 'text_inhalt' | 'datum'>): ForwardKontext => ({
  id: email.id,
  betreff: email.betreff || '',
  html_inhalt: email.html_inhalt || undefined,
  text_inhalt: email.text_inhalt || (email.html_inhalt ? htmlZuText(email.html_inhalt) : undefined),
  datum: email.datum || undefined,
});
